export default __webpack_public_path__ + "static/media/black-walnut-full-double.350bc94e.jpg";